import { render, staticRenderFns } from "./CommodityExchange.vue?vue&type=template&id=689a2235&scoped=true&"
import script from "./CommodityExchange.vue?vue&type=script&lang=ts&"
export * from "./CommodityExchange.vue?vue&type=script&lang=ts&"
import style0 from "./CommodityExchange.vue?vue&type=style&index=0&id=689a2235&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689a2235",
  null
  
)

export default component.exports